import { AxiosResponse } from 'axios';
import LoginService from 'pages/login/login.service';
import { axiosRequest } from '../../../axios/axios.config';
import { ItemGerarSkuTrocaSerial, SkuTrocaSerialGerado } from './cupom-troca.model';

const CupomTrocaService = () => {
    const path = 'skutrocaserial';
    const loginService = LoginService();

    return {
        gerarSkuTrocaSerial: (
            pedidoVendaUuid: string,
            itens: Array<ItemGerarSkuTrocaSerial>,
        ): Promise<AxiosResponse<Array<SkuTrocaSerialGerado>>> => {
            return axiosRequest.post(
                `${path}/gerar`,
                { pedidoVendaUuid, itens },
                { headers: loginService.getHeaders() },
            );
        },
    };
};

export default CupomTrocaService;
